import type { ReactNode } from 'react';

import { Dropdown } from '#/components/Dropdown/Dropdown';
import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetVolopsRoutePath } from '#/modules/search/routing/helpers/searchGetVolopsRoutePath';

import { VolunteerDropdownMenu } from './VolunteerDropdownMenu';

type Props = {
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
  trackClickedContext: string;
};

const triggerTextByLocale: Record<I18nLocale, { text: string; href: string }> =
  {
    en: {
      text: 'Volunteer',
      href: searchGetVolopsRoutePath({
        locale: I18nLocale.EN,
        embedSearchWidgetId: null,
      }),
    },
    es: {
      text: 'Voluntariado',
      href: searchGetVolopsRoutePath({
        locale: I18nLocale.ES,
        embedSearchWidgetId: null,
      }),
    },
    pt: {
      text: 'Conectar',
      href: searchGetVolopsRoutePath({
        locale: I18nLocale.PT,
        embedSearchWidgetId: null,
      }),
    },
  };

export function VolunteerDropdown({
  renderTrigger,
  trackClickedContext,
}: Props) {
  const { locale } = useI18n();
  const { text, href } = triggerTextByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText: text, triggerHref: href })}
      desktopTriggersOnHover
    >
      <VolunteerDropdownMenu trackClickedContext={trackClickedContext} />
    </Dropdown>
  );
}
